/////////////////////////////////////////////////
// Add this GraphQL to the schema.graphql files
// Then run amplify update api and amplify push

// type Investor @model {
//   id: ID!
//   firstname: String!
//   lastname: String!
//   address: String!
//   city: String!
//   state: String!
//   zip: String!
//   email: AWSEmail!
//   phone: AWSPhone!
//   income: Boolean!
//   assets: Boolean!
//   experience: Boolean!
//   signature: String!
// }
/////////////////////////////////////////////////

// Set the inital state of the API object
const Model = {
  initialState: {
    firstname: '',
    lastname: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    income: '',
    assets: false,
    experience: false,
  },
};

export default Model;
